import { QUESTIONNAIRE_EVALUATION as MODULE_PREFIX } from '../constants';
export const QUESTIONNAIRE_EVALUATION_INITIALIZATION_POST_REQUEST = `${MODULE_PREFIX}_INITIALIZATION_POST_REQUEST`;
export const QUESTIONNAIRE_EVALUATION_INITIALIZATION_POST_SUCCESS = `${MODULE_PREFIX}_INITIALIZATION_POST_SUCCESS`;
export const questionnaireEvaluationInitializationPostAction = requestData => ({
    type: QUESTIONNAIRE_EVALUATION_INITIALIZATION_POST_REQUEST,
    payload: requestData
});
export const questionnaireEvaluationInitializationPostSuccessAction = evaluationDocId => ({
    type: QUESTIONNAIRE_EVALUATION_INITIALIZATION_POST_SUCCESS,
    payload: evaluationDocId
});
//# sourceMappingURL=questionnaireEvaluationInitializationPostActions.js.map